<template>
  <div>
    <Head title="Reports" />
    <h1 class="mb-8 text-3xl font-bold">Meldebox</h1>

    <p class="mb-3 leading-5">
      <strong>Interne Meldestelle nach dem Hinweisgeberschutzgesetz</strong><br>
      Wir haben gemäß <a class="border-b border-gray-700 hover:border-indigo-500" href="https://www.recht.bund.de/bgbl/1/2023/140/VO.html" target="_blank">Hinweisgeberschutzgesetz</a> eine interne Meldestelle eingerichtet, zu der hinweisgebende Personen vertraulich und anonym Kontakt aufnehmen können. Die Meldestelle nimmt Meldungen zu Missständen innerhalb des Geschäftsbereichs der Erwin Rumpf Garten- und Landschaftsbau entgegen. Die Meldestelle steht allen natürlichen Personen zur Meldung von Regel- oder Gesetzesverstößen offen, die im Rahmen ihrer beruflichen Tätigkeit mit unserem Geschäftsbereich in Verbindung stehen, wie z.B. Beschäftigte, Lieferanten, Dienstleister oder andere Geschäftspartner. Wir behandeln alle Meldungen und personenbezogenen Daten mit besonderer Vertraulichkeit nach höchsten datenschutzrechtlichen Standards und Anforderungen.
    </p>

    <p class="mb-3 leading-5">
      Der besondere gesetzliche Schutz der Hinweisgeber gilt nicht bei vorsätzlich oder grob fahrlässig abgegebenen Meldungen.
    </p>

    <p class="mb-3 leading-5">
      Unsere interne Meldestelle ist wie folgt erreichbar:
    </p>

    <p class="mb-3 leading-5">
      <strong>Meldeformular</strong><br>
      Bei Kontaktaufnahme per Meldeformular werden Ihre Daten anonymisiert
    </p>

    <div class="my-16 mx-auto w-2/3 flex gap-4">
      <div class="w-1/2 h-64 p-8 bg-gray-300 flex items-center justify-center">
        <a class="btn-indigo text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-lg px-5 py-2.5 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800" href="/meldung">Neue Eingabe</a>
      </div>

      <div class="w-1/2 h-64 bg-gray-300 p-8 flex flex-col gap-4  items-center justify-center">
        <text-input v-model="kennwort" class="pb-8 pr-6 w-full" label="Kennwort" />
        <a class="btn-indigo text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-lg px-5 py-2.5 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800" :href="`/meldung/${kennwort}`">bestehende Meldung aufrufen.</a>
      </div>
    </div>

    <p class="mb-3 leading-5">
      <strong>Email</strong><br>
      hinweis@rumpf-galabau.de<br>
      Telefonisch +49 (0)4392 912037 (Servicezeit von 07:00 Uhr bis 17:00 Uhr)<br>
      Montag bis Freitag außer gesetzliche Feiertage
    </p>

    <p class="mb-3 leading-5">
      <strong>Schriftlich</strong><br>
      Erwin Rumpf Garten- und Landschaftsbau GmbH & Co. KG<br>
      Meldestelle Hinweisgeberschutzgesetz<br>
      Eichenallee 6<br>
      24589 Nortorf
    </p>

    <p class="mb-3 leading-5">
      Bei Kontaktaufnahme per Brief kennzeichnen Sie Ihr Schreiben auf dem Umschlag bitte als vertraulich. Wünschen Sie ein persönliches Treffen, teilen Sie uns dies gerne auf einem der o.g. Wege mit.
    </p>

    <p class="mb-3 leading-5">
      <strong>Externe Meldestellen</strong><br>
      Neben unserer o. g. internen Meldestelle können sich hinweisgebende Personen auch an eine externe Meldestelle des Bundes beim Bundesamt für Justiz, bei der Bundesanstalt für Finanzdienstleistungsaufsicht sowie beim Bundeskartellamt wenden.
    </p>

    <p class="mb-3 leading-5">
      Diese sind erreichbar unter:
    </p>

    <p class="mb-3 leading-5">
      <a class="border-b border-gray-700 hover:border-indigo-500" href="https://www.bundesjustizamt.de/DE/MeldestelledesBundes/MeldestelledesBundes.html" target="_blank">https://www.bundesjustizamt.de/DE/MeldestelledesBundes/MeldestelledesBundes.html</a>
    </p>

    <p class="mb-3 leading-5">
      <a class="border-b border-gray-700 hover:border-indigo-500" href="https://www.bafin.de/DE/DieBaFin/Hinweisgeberstelle/hinweisgeberstelle_node.html" target="_blank">https://www.bafin.de/DE/DieBaFin/Hinweisgeberstelle/hinweisgeberstelle_node.html</a>
    </p>

    <p class="mb-3 leading-5">
      <a class="border-b border-gray-700 hover:border-indigo-500" href="https://www.bundeskartellamt.de/DE/Kartellverbot/Anonyme_Hinweise/anonymehinweise_node.html" target="_blank">https://www.bundeskartellamt.de/DE/Kartellverbot/Anonyme_Hinweise/anonymehinweise_node.html</a>
    </p>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout2'
import TextInput from '@/Shared/TextInput'

export default {
  components: {
    Head,
    TextInput,
  },
  layout: Layout,
  data() {
    return {
      kennwort: '',
    }
  },
}
</script>
